exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-panel-content[data-v-ba06a504]{border:1px solid #dee2e6;border-radius:0 .25rem .25rem .25rem;padding:.75rem 1rem .5rem}.filter-col[data-v-ba06a504]{padding-top:.25rem;padding-bottom:.25rem}.filter-checkbox-group[data-v-ba06a504]{display:grid!important;grid-template-columns:repeat(4,1fr);gap:.35rem 0}.filter-group-label[data-v-ba06a504]{font-size:.75rem;font-weight:600;text-transform:uppercase;letter-spacing:.05em;color:#6c757d;margin-bottom:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ba06a504","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/BrandsFilter.vue
// module id = 821
// module chunks = 0